import React, { useState } from 'react';
import { G, styles } from '../theme.js';
import { Btn, Modal } from '../ui.jsx';

// First-run tour for techs. Shows once per tech (gated by localStorage key
// tradeops:tech-tour-seen). Five quick cards covering the highest-leverage
// daily actions:
//   1. Clock in to start your day
//   2. Tap a job to see address + customer notes
//   3. Status flow: tap to advance (Scheduled → Enroute → Working → Done)
//   4. Take payment in-app the moment work is done
//   5. Review the truck checklist before you leave
// Skippable + replayable from Settings.

const SLIDES = [
  {
    icon: '⏰',
    title: 'Clock in to start your day',
    body: 'Tap the big "Clock In" card at the top of Today. It logs your hours automatically — you don\'t have to remember to clock out, the system reminds you.',
  },
  {
    icon: '📍',
    title: 'Tap a job to see everything you need',
    body: 'Customer name + phone + full address (one tap opens maps), gate codes / pet notes from the office, materials sold on the estimate, and the on-site equipment the office knows about.',
  },
  {
    icon: '🟢',
    title: 'Status flow — tap to advance',
    body: 'Scheduled → Enroute → On Site → Working → Done. Each tap auto-texts the customer ("Tech is 20 min away", "Tech arrived", "Work complete"). You don\'t write the texts.',
  },
  {
    icon: '💳',
    title: 'Take payment the moment work is done',
    body: 'Open the job, tap "Collect Payment", enter the amount + add lines if needed, the customer gets a text link. Card / Apple Pay / Google Pay / ACH — all in. Lands as paid in 60 seconds.',
  },
  {
    icon: '🚐',
    title: 'Check the van checklist before you head out',
    body: 'Every job has a van/truck checklist tuned to your trade (electrical, HVAC, plumbing, roofing) — tools, stock, and the specific parts from the customer\'s estimate. Don\'t leave the shop without it.',
  },
];

export function TechOnboardingTour() {
  const [idx, setIdx] = useState(() => {
    try { return localStorage.getItem('tradeops:tech-tour-seen') === '1' ? -1 : 0; } catch { return 0; }
  });
  if (idx < 0 || idx >= SLIDES.length) return null;
  const slide = SLIDES[idx];
  const isLast = idx === SLIDES.length - 1;
  const dismiss = () => {
    try { localStorage.setItem('tradeops:tech-tour-seen', '1'); } catch {}
    setIdx(-1);
  };
  return <Modal open onClose={dismiss} width={420}>
    <div style={{ textAlign:'center', padding:'8px 6px' }}>
      <div style={{ fontSize:48, marginBottom:10 }}>{slide.icon}</div>
      <h2 style={{ margin:'0 0 10px', fontSize:20 }}>{slide.title}</h2>
      <div style={{ color:G.textMuted, fontSize:14, lineHeight:1.55 }}>{slide.body}</div>
    </div>
    <div style={{ display:'flex', justifyContent:'center', gap:6, margin:'18px 0 14px' }}>
      {SLIDES.map((_, i) => (
        <div key={i} style={{ width: i === idx ? 22 : 8, height:8, borderRadius:4, background: i === idx ? G.purple : G.input, transition:'.2s' }}/>
      ))}
    </div>
    <div style={{ display:'flex', justifyContent:'space-between', gap:10 }}>
      <Btn v="ghost" sz="sm" onClick={dismiss}>Skip tour</Btn>
      {!isLast ? <Btn v="primary" sz="sm" onClick={()=>setIdx(idx+1)}>Next →</Btn>
        : <Btn v="primary" sz="sm" onClick={dismiss}>Got it</Btn>}
    </div>
  </Modal>;
}
